import React, { useState, useContext, useEffect } from "react";
import { hasRole } from "../utils/guestUser";
import "../Styles/Dashboard_graph4.css";
import "../Styles/Dashboard.css";
import { MenuItem } from "@mui/material";
import { Select } from "@mui/material";
import { AuthContext } from "../context/AuthContext";
import { UserContext } from "../context/UserContext";
import { useNavigate } from "react-router-dom";
import {
  clientApiUrl,
  taskApiUrl,
  notificationApiUrl,
  userApiUrl,
} from "../utils/GetUrl";
function Dashboard_graph_4() {
  const navigate = useNavigate();
  const handleClick2 = () => {
    navigate("/controlreports");
  };
  const { token, userData } = useContext(AuthContext);
  const { teamsData, usersList } = useContext(UserContext);
  const [selectedTeam, setSelectedTeam] = useState(
    (hasRole(userData?.[0]?.DR_Name, "Admin") || hasRole(userData?.[0]?.DR_Name, "Super Admin") || hasRole(userData?.[0]?.DR_Name, "Managing Director")) ? "" : (userData?.[0]?.STM_Team ?? "")
  );
  const [filteredEmployeeList, setFilteredEmployeeList] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString());

  const [controlData, setControlData] = useState([]);
  const [filteredControlData, setFilteredControlData] = useState({
    completed: 0,
    pending: 0,
    notUpdated: 0,
    overdue: 0,
  });

  const fetchControlData = async (monthString) => {
    const [year, month] = monthString?.split("-"); // Split the monthString into year and month

    // ---- CURRENT MONTH ----

    // Last day of current month
    const lastDay = new Date(year, month, 0).getDate();
    const firstDay = "01";

    // Add time
    const formattedDateRange1 = `${year}-${month}-${firstDay} 00:00:00`;
    const formattedDateRange2 = `${year}-${month}-${String(lastDay).padStart(
      2,
      "0"
    )} 23:59:59`;

    // ---- PREVIOUS MONTH ----
    const prevMonth = month === "01" ? 12 : Number(month);
    const prevYear = month === "01" ? Number(year) - 1 : year;

    // Last day of previous month
    const prevLastDay = new Date(prevYear, prevMonth, 0).getDate();

    // Add time
    const prevFormattedDateRange1 = `${prevYear}-${String(prevMonth).padStart(
      2,
      "0"
    )}-01 00:00:00`;
    const prevFormattedDateRange2 = `${prevYear}-${String(prevMonth).padStart(
      2,
      "0"
    )}-${String(prevLastDay).padStart(2, "0")} 23:59:59`;


    // Helper function to chunk an array into smaller arrays of a given size
    const chunkArray = (arr, chunkSize) => {
      const chunks = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize));
      }
      return chunks;
    };

    // Ensure filteredEmployeeList is an array of strings by splitting it on commas
    const filteredEmployeeListArray =
      typeof filteredEmployeeList === "string"
        ? filteredEmployeeList.replace(/'/g, "").split(",")
        : "";

    if (selectedTeam && filteredEmployeeListArray[0] == "") {
      setFilteredControlData({
        completed: 0,
        pending: 0,
        notUpdated: 0,
        overdue: 0,
      });
      return;
    }

    // Split the filteredEmployeeList into chunks of 20
    const employeeChunks = chunkArray(filteredEmployeeListArray, 20);

    const fetchDataForEmployeeChunk = async (chunk) => {
      // Ensure chunk is an array of strings and join them with commas for the API request
      const employeeIds = chunk.join(",");

      // Fetch current month's data for the chunk
      const currentMonthResponse = await fetch(
        `${taskApiUrl}/GetControlPointMapping?DateRange1=${formattedDateRange1}&DateRange2=${formattedDateRange2}&Emids=${employeeIds}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (currentMonthResponse?.status === 401) {
        return;
      }
      if (!currentMonthResponse.ok) {
        throw new Error("Network response was not ok");
      }
      const currentMonthData = await currentMonthResponse.json();

      // Fetch previous month's data for the chunk
      const prevMonthResponse = await fetch(
        `${taskApiUrl}/GetControlPointMapping?DateRange1=${prevFormattedDateRange1}&DateRange2=${prevFormattedDateRange2}&Emids=${employeeIds}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (prevMonthResponse?.status === 401) {
        return;
      }
      if (!prevMonthResponse.ok) {
        throw new Error("Network response was not ok");
      }
      const prevMonthData = await prevMonthResponse.json();

      return { currentMonthData, prevMonthData };
    };

    try {
      // Fetch chunks in small batches rather than all at once, to avoid
      // overloading the task function app (429 / CORS-masked failures under
      // burst load). Results are concatenated + aggregated below, so batching
      // changes only the request pacing — not the outcome.
      const allData = [];
      const CHUNK_BATCH_SIZE = 3;
      for (let i = 0; i < (employeeChunks?.length || 0); i += CHUNK_BATCH_SIZE) {
        const batch = employeeChunks.slice(i, i + CHUNK_BATCH_SIZE);
        // eslint-disable-next-line no-await-in-loop
        const batchData = await Promise.all(batch.map(fetchDataForEmployeeChunk));
        allData.push(...batchData);
      }

      let combinedCurrentMonthData = [];
      let combinedPrevMonthData = [];

      // Combine all the fetched data
      allData.forEach(({ currentMonthData, prevMonthData }) => {
        combinedCurrentMonthData =
          combinedCurrentMonthData?.concat(currentMonthData);
        combinedPrevMonthData = combinedPrevMonthData?.concat(prevMonthData);
      });

      // Helper function to check if the control point is overdue based on frequency
      const isOverdue = (item, isPrevMonth = false) => {
        const today = new Date();
        const controlDate = new Date(item.CreatedDate);

        // Helper function to determine the end of a quarter
        const isQuarterOverdue = (controlDate) => {
          const currentMonth = today.getMonth();
          const quarterEndMonths = [2, 5, 8, 11]; // March, June, September, December

          // Check if the control point was created in or before the last quarter
          const controlQuarter = quarterEndMonths.find(
            (month) => controlDate.getMonth() <= month
          );
          const nextQuarterEnd = new Date(
            today.getFullYear(),
            controlQuarter,
            31
          ); // End of current quarter

          return today > nextQuarterEnd; // Overdue if today is past the quarter's end
        };

        switch (item.Frequency) {
          case "Daily":
            return controlDate < today; // Daily: Check if control point is before today
          case "Weekly":
            const nextWeek = new Date(controlDate);
            nextWeek.setDate(controlDate.getDate() + 7); // Weekly: Add 7 days
            return nextWeek < today;
          case "Bi-Monthly":
            const currentMonth = today.getMonth();
            const firstCheckDate = new Date(controlDate);
            firstCheckDate.setDate(14); // Assume Bi-Monthly check happens on 14th and 28th
            const secondCheckDate = new Date(controlDate);
            secondCheckDate.setDate(28);
            return (
              today > firstCheckDate &&
              today > secondCheckDate &&
              currentMonth === controlDate.getMonth()
            );
          case "Monthly":
            const nextMonth = new Date(controlDate);
            nextMonth.setMonth(controlDate.getMonth() + 1); // Monthly: Add 1 month
            return nextMonth < today;
          case "Quarterly":
            if (isPrevMonth) {
              return isQuarterOverdue(controlDate); // Check if the previous quarter is overdue
            } else {
              const nextQuarter = new Date(controlDate);
              nextQuarter.setMonth(controlDate.getMonth() + 3); // Quarterly: Add 3 months
              return nextQuarter < today;
            }
          default:
            return isPrevMonth;
        }
      };

      // Pending control points (P status)
      const pending = combinedCurrentMonthData?.filter(
        (item) => item.Status?.toUpperCase() === "P" && !isOverdue(item)
      ).length;

      // Not updated control points (P status in previous month)
      const notUpdated = combinedPrevMonthData?.filter(
        (item) => item.Status?.toUpperCase() === "NA"
      ).length;

      // Completed control points (C status)
      const completed = combinedCurrentMonthData?.filter(
        (item) => item.Status?.toUpperCase() === "C"
      ).length;

      // Overdue control points (P status and created date is passed)
      const overdue1 = combinedCurrentMonthData?.filter(
        (item) => item.Status?.toUpperCase() === "P" && isOverdue(item)
      ).length;

      const overdue2 = combinedPrevMonthData?.filter(
        (item) => item.Status?.toUpperCase() === "P" && isOverdue(item)
      ).length;

      const overdue = overdue1 + overdue2;

      // Log or use the variables as needed
      // Update the state with the computed values
      setFilteredControlData({ completed, pending, notUpdated, overdue });
    } catch (error) {
      console.error("Error fetching control data:", error);
    }
  };

  useEffect(() => {
    fetchControlData(selectedMonth);
  }, [token, filteredEmployeeList, selectedMonth]);

  function handleMonthChange(monthString) {
    setSelectedMonth(monthString);
  }
  const currentDate = new Date();
  const currentMonthYear = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1
  ).padStart(2, "0")}`;

  const handleTeamChange = (e) => {
    const value = e.target.value;
    setSelectedTeam(value);
  };

  useEffect(() => {
    // alert(selectedTeam)
    let filteredEmployees;
    if (!selectedTeam) {
      filteredEmployees = usersList;
    } else {
      filteredEmployees = usersList?.filter(
        (user) => user?.STM_Team == selectedTeam
      );
    }

    setFilteredEmployeeList(
      filteredEmployees?.map((item) => `'${item["EM_ID"]}'`).join(",")
    );
  }, [selectedTeam]);

  const handleClick = () => {
    navigate("/QualityControl");
  };

  return (
    <div className="g4-main">
      <div className="g4-main-drop-div">
        <div
          className="g4-head"
          onClick={handleClick}
          style={{ cursor: "pointer" }}
        >
          Control points
        </div>
        <div className="dropdown-g4-side-right">
          <div>
            <input
              type="month"
              value={selectedMonth.slice(0, 7)}
              onChange={(e) => handleMonthChange(e.target.value)}
              className="calstyle-for-dashboard"
            />
          </div>
          {(hasRole(userData?.[0]?.DR_Name, "Admin") || hasRole(userData?.[0]?.DR_Name, "Super Admin") || hasRole(userData?.[0]?.DR_Name, "Managing Director") || !hasRole(userData?.[0]?.DR_Name, "Consultant")) && (
            <Select
              fullWidth
              value={selectedTeam}
              onChange={handleTeamChange}
              displayEmpty
            >
              <MenuItem value="">All Teams</MenuItem>
              {teamsData[0]
                ?.filter((team) => team?.status === true && team?.type === "T")
                ?.map((data) => (
                  <MenuItem key={data.id} value={data.id}>
                    {data.name}
                  </MenuItem>
                ))}
            </Select>
          )}
        </div>
      </div>
      <div className="g4-subhead">Live status of control points</div>
      <div className="g4-cards-div">
        <div
          className="g4-card1-dash"
          onClick={handleClick2}
          style={{ cursor: "pointer" }}
        >
          <div className="g4-card1-dash-c1">Completed :</div>
          <div className="g4-card1-dash-c2">
            {filteredControlData.completed}
          </div>
        </div>
        <div
          className="g4-card2-dash"
          onClick={handleClick2}
          style={{ cursor: "pointer" }}
        >
          <div className="g4-card1-dash-c1">Pending :</div>
          <div className="g4-card1-dash-c3">{filteredControlData.pending}</div>
        </div>
        <div
          className="g4-card3-dash"
          onClick={handleClick2}
          style={{ cursor: "pointer" }}
        >
          <div className="g4-card1-dash-c1">OverDue :</div>
          <div className="g4-card1-dash-c4">{filteredControlData.overdue}</div>
        </div>
      </div>
      <div className="g4-dash-footer">
        <div className="g4-dash-footer-data">
          Total count and time utilized Count :
          <span className="g4-dash-footer-spam">
            {filteredControlData.completed +
              filteredControlData.pending +
              filteredControlData.notUpdated}{" "}
            {/* | Time : 111 */}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Dashboard_graph_4;
